<template>
  <div class="centerBox">
    <div>
      <div class="title">请核实您的基本信息</div>
      <div class="content">
        <div>权利人名称：{{ user.obligeeName }}</div>
        <div>业务号：{{ user.ywh }}</div>
        <div>应缴金额：¥ {{ user.paymentTotal }}</div>
      </div>
      <div class="tips">
        线上缴费仅能提供电子票据，如需纸质票据请至对应
        政务中心不动产登记窗口线下缴费。
      </div>
      <div class="btn" @click="pay" v-if="isPay">确认缴费</div>
      <div class="btn" @click="showTicket" v-else>查看电子票</div>
    </div>
    <div id="widget" />
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
let loadedMineMapJs = false;
export default {
  name: "registerCenter",
  data() {
    return {
      user: {},
      dataInfo: {},
      isPay: true, //判断是支付还是回调
    };
  },
  created() {
    this.dataInfo = this.$route.query;
    if (this.dataInfo.resultType) {
      //回调
      this.isPay = false;
      this.getBackData();
    } else {
      this.isPay = true;
      this.getData();
    }
  },
  methods: {
    getData() {
      this.request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url: "/hnbdc_pay/getQrcodeData",
        method: "get",
        params: this.dataInfo,
      }).then((res) => {
        if (res.data.code == 1000) {
          this.user = res.data.result;
        } else {
          if (!res.data.errorMessage) {
            Dialog.alert({
              title: "提示",
              message: res.data.message,
            });
          }
        }
      });
    },
    getBackData() {
      this.request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url: "/hnbdc_pay/frontBackData",
        method: "get",
        params: {
          id: this.dataInfo.id,
        },
      }).then((res) => {
        if (res.data.code == 1000) {
          this.user = res.data.result;
        } else {
          if (!res.data.errorMessage) {
            Dialog.alert({
              title: "提示",
              message: res.data.message,
            });
          }
        }
      });
    },
    pay() {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      let data = {
        id: this.user.id,
        totalAmt: this.user.paymentTotal,
      };
      if (window.localStorage.getItem("payRouteBack")) {
        window.localStorage.removeItem("payRouteBack");
      }
      this.request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url: "/hnbdc_pay/payInitHnBdcData",
        method: "post",
        data: data,
      }).then((res) => {
        if (res.data.code == 1000) {
          //未加载成功
          if (!loadedMineMapJs) {
            this.asyncLoadJs(res.data.result.thirdpayWidgetJs).then(() => {
              loadedMineMapJs = true;
              this.otherPay(res.data.result);
            });
            // 已经加载成功
          } else {
            this.otherPay(res.data.result);
          }
        } else {
          Toast.clear();
          Dialog.alert({
            title: "提示",
            message: res.data.message,
          });
        }
      });
    },
    asyncLoadJs(url) {
      var Q = require("q");
      return Q.Promise((resolve, reject) => {
        let srcArr = document.getElementsByTagName("script");
        let hasLoaded = false;
        for (let i = 0; i < srcArr.length; i++) {
          //判断当前js是否加载上
          hasLoaded = srcArr[i].src == url ? true : false;
        }
        if (hasLoaded) {
          resolve();
          return;
        }
        let script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        document.body.appendChild(script);
        script.onload = () => {
          resolve();
        };
        script.onerror = () => {
          reject();
        };
      });
    },
    otherPay(res) {
      let obj = {
        container: "widget", // 挂件在当前页面放置的控件ID
        merchant_no: res.merchant_no, // 分配的商户号
        merchant_order_no: res.merchant_order_no, // 订单在商户系统中的订单号
        amount: res.amount, // 订单价格，单位：人民币 分
        widget_param: res.widget_param,
        subject: res.subject,
        body: res.body,
        charge_url: res.charge_url, // 商户服务端创建Charge字符串的url
        charge_param: res.charge_param,
        device_type: res.device_type, // 设备类型
        effective_time: res.effective_time, // 当天有效，24点失效
        version_no: res.version_no,
      };
      // 微信小程序中，多加几个参数
      //   if (this.isWxmp) {
      //     this.$set(obj,'paymentName',res.paymentName)
      //     this.$set(obj,'itemNameSet',res.itemNameSet)
      //   }
      let that = this;
      const interval = setInterval(() => {
        if (loadedMineMapJs) {
          clearInterval(interval);
          // 调起支付
          thirdpay_widget.init(obj);
          Toast.clear();
        }
      }, 100);
    },
    // 查看电子票
    showTicket() {
      this.request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url: "/hnbdc_pay/checkBill",
        method: "get",
        params: {
          id: this.dataInfo.id,
        },
      }).then((res) => {
        if (res.data.code == 1000) {
          this.$router.push({
            path: "/eTicket?url=" + encodeURIComponent(res.data.message),
          });
        } else {
          if (!res.data.errorMessage) {
            Dialog.alert({
              title: "提示",
              message: res.data.message,
            });
          }
        }
      });
    },
  },
};
</script>

<style  lang='scss' scoped>
.centerBox {
  background-color: #fff;
  min-height: 100vh;
  .title {
    font-size: 17px;
    color: #2e3133;
    text-align: center;
    padding: 50px 0 20px;
    font-weight: bolder;
  }
  .content {
    font-family: PingFangSC-Regular;
    font-size: 15px;
    color: #2e3133;
    line-height: 35px;
    padding: 0 10vw;
  }
  .tips {
    background: rgba(250, 173, 20, 0.1);
    border-radius: 2px;
    border-radius: 2px;
    width: 90vw;
    margin: 40px auto 0;
    padding: 16px 30px;
    line-height: 24px;
    box-sizing: border-box;
    text-align: center;
    color: #faad14;
  }
  .btn {
    width: 90vw;
    margin: 30px auto;
    background: #2d8dfd;
    border-radius: 2px;
    font-size: 15px;
    color: #ffffff;
    height: 44px;
    line-height: 44px;
    text-align: center;
  }
}
</style>